// Development source only.
//
// Spec s4 excludes the local mic from the production pipeline: the remote track
// already carries everything the other party said, and including local audio
// means dealing with echo. This exists so the pipeline can be driven from a
// laptop with no call running. It is not wired into the LiveSwitch path.

import { BaseAudioSource } from '../AudioSource';
import { MonoMixerGraph } from '../MonoMixerGraph';

export class MicAudioSource extends BaseAudioSource {
  private graph = new MonoMixerGraph();
  private stream: MediaStream | null = null;

  async start(): Promise<void> {
    await this.graph.start();
    this.graph.onFrame((pcm, timestampMs) => this.emitFrame(pcm, timestampMs));

    this.stream = await navigator.mediaDevices.getUserMedia({
      audio: { echoCancellation: true, noiseSuppression: true, channelCount: 1 },
    });
    const track = this.stream.getAudioTracks()[0];
    if (!track) throw new Error('no microphone track available');
    this.graph.addTrack('local-mic', track);
  }

  async stop(): Promise<void> {
    this.stream?.getTracks().forEach((track) => track.stop());
    this.stream = null;
    await this.graph.stop();
  }
}
